import React from 'react';
import { withStyles, Box, Typography } from '@material-ui/core';
import styles from './styles';
import Button from 'storybookComponents/Button';
import HylyLogo from 'images/hylylogo-white.svg';

const HomePage = withStyles(styles)(({ classes, ...props }) => {

  return (
    <Box className={classes.root}>
      <Box className={classes.titleBox} display="flex" justifyContent="center" alignItems="flex-end">
        <Box display="flex" alignItems="center">
          <img src={HylyLogo} alt="hyly" />
          <Typography className={classes.title}>hy<strong>Events</strong></Typography>
        </Box>
      </Box>
      <Box className={classes.actionBox} display="flex" justifyContent="flex-start" alignItems="center" flexDirection="column">
        <Typography variant="h6" className={classes.text}>Multifamily</Typography>
        <Typography variant="h6" className={classes.text}><strong>Managing Events Made Easy!!!</strong></Typography>
        <Box className={classes.buttonWrapper}>
          <Button
            color="primary"
            label="sign in"
            onClick={props.handleSignin}
            variant="primary"
            size="lg"
          >sign in</Button>
        </Box>
        {/* <Box className={classes.tourWrapper}>
          Want to know about hyEvents? Take a <span className={classes.tour}>Quick Tour</span>
        </Box> */}
      </Box>
    </Box>
  )
});

export default HomePage;